// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__38gIJ","header":"PatientBlock_header__2gV8u","label":"PatientBlock_label__3s6cu","option":"PatientBlock_option__3PXvR"};